function* sync(n, value) {
    for (let i = 0; i < n; i++) {
        yield value;
    }
}
function repeat(n, value) {
    if (value === undefined) {
        return (value) => {
            return repeat(n, value);
        };
    }
    return sync(n, value);
}
export default repeat;
//# sourceMappingURL=repeat.js.map